import { useQuery } from "hooks/useQuery";
import { getStrategyOverview } from "features/Strategy/service";

export const useStrategyOverview = (strategyId) => {
  return useQuery({
    key: "strategyOverview",
    queryKey: ["strategyOverview", strategyId],
    queryFn: async () => {
      const response = await getStrategyOverview(strategyId);
      return response;
    },
    enabled: !!strategyId,
  });
};
